<template>
  <div>
    <vs-collapse type="margin">
      <vs-collapse-item
        v-for="(routine, index) in routines"
        :key="routine.id"
        class="mb-2 mt-4"
        :data-testId="`routine-form-${index}`"
      >
        <div slot="header" class="flex justify-between">
          <h4>{{ routine.name }}</h4>
        </div>
        <vs-row>
          <vs-col vs-type="flex" vs-justify="flex-end" vs-align="top" vs-w="12" class="mb-2">
            <div class="flex items-center gap-1">
              <label for="">Ativo</label>
              <vs-switch
                color="success"
                v-model="routine.active"
                style="width: 60px"
                :data-testId="`active-switch-${index}`"
              >
                <span slot="on">Sim</span>
                <span slot="off">Não</span>
              </vs-switch>
            </div>
          </vs-col>
          <vs-col vs-justify="center" vs-align="center" vs-w="3">
            <label class="vs-input--label">Tipo de Intervalo</label>
            <vs-select
              v-model="routine.intervalType"
              class="select-medium w-full"
              :name="`Tipo de Intervalo-${index}`"
              :id="`tipoIntervalo-${index}`"
              v-validate="{ required: true }"
              :state="validateState(`Tipo de Intervalo-${index}`)"
              :class="validateClass(`Tipo de Intervalo-${index}`)"
              :data-testId="`interval-type-select-${index}`"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.label"
                v-for="(item, index) in routineIntervalTypes"
              />
            </vs-select>
          </vs-col>
          <vs-col
            v-if="routine.intervalType === RoutineIntervalType.EVERY_DAY_AT"
            vs-justify="center"
            vs-align="center"
            vs-w="3"
          >
            <vs-input
              label="Intervalo"
              :name="`Intervalo-${index}`"
              :id="`Intervalo-${index}`"
              icon-pack="feather"
              icon="icon-clock"
              class="w-full"
              v-mask="'##:##'"
              v-validate="{ required: true, min: 5 }"
              @input="validateTime(index)"
              v-model="routine.intervalValue"
              :state="validateState(`Intervalo-${index}`)"
              :danger="validateClass(`Intervalo-${index}`)"
              :data-testId="`every-day-at-input-${index}`"
            ></vs-input>
          </vs-col>
          <vs-col
            v-if="routine.intervalType === RoutineIntervalType.EVERY"
            vs-justify="center"
            vs-align="center"
            vs-w="3"
          >
            <vs-input
              label="Intervalo"
              :name="`Intervalo-${index}`"
              :id="`Intervalo-${index}`"
              icon-pack="feather"
              icon="icon-clock"
              class="w-full"
              type="number"
              min="1"
              v-validate="{ required: true, min: 1 }"
              v-model="routine.intervalValue"
              :state="validateState(`Intervalo-${index}`)"
              :danger="validateClass(`Intervalo-${index}`)"
              :data-testId="`every-input-${index}`"
            ></vs-input>
          </vs-col>
          <vs-col
            v-if="routine.intervalType === RoutineIntervalType.EVERY"
            vs-justify="center"
            vs-align="center"
            vs-w="3"
          >
            <label class="vs-input--label">Unidade do Intervalo</label>
            <vs-select
              v-model="routine.intervalUnity"
              class="select-medium w-full"
              :name="`Unidade do Intervalo-${index}`"
              :id="`unidadeIntervalo-${index}`"
              v-validate="{ required: true }"
              :state="validateState(`Unidade do Intervalo-${index}`)"
              :class="validateClass(`Unidade do Intervalo-${index}`)"
              :data-testId="`interval-unity-select-${index}`"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.label"
                v-for="(item, index) in routineIntervalUnities"
              />
            </vs-select>
          </vs-col>
          <vs-col vs-justify="center" vs-align="center" vs-w="3">
            <vs-input
              label="Bloqueio para execução paralela"
              icon-pack="feather"
              icon="icon-lock"
              class="w-full"
              type="number"
              min="1"
              placeholder="em minutos"
              v-model="routine.lockInMinutes"
              :data-testId="`parallelExecutionBlock-input-${index}`"
            ></vs-input>
          </vs-col>
          <vs-col
            v-if="companyWritePermission"
            vs-type="flex"
            vs-justify="flex-end"
            vs-w="12"
          >
            <vs-button
              color="primary"
              type="relief"
              class="mb-3 mt-4"
              @click.prevent="saveConfig(routine)"
              :disabled="hasInvalidFields(index)"
              :data-testId="`save-button-${index}`"
            >
              Salvar
            </vs-button>
          </vs-col>
        </vs-row>
      </vs-collapse-item>
    </vs-collapse>
  </div>
</template>

<script>
import {
  RoutineIntervalType,
  RoutineIntervalTypeLabel,
  RoutineIntervalUnity,
  RoutineIntervalUnityLabel,
} from '@/utils/constants';


export default {
  name: 'RoutinesForm',
  components: {},
  props: {
    subjectPermission: {
      type: String,
    },
    routinesProp: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      RoutineIntervalType,
      routineIntervalTypes: [
        {
          label: RoutineIntervalTypeLabel[RoutineIntervalType.EVERY_DAY_AT],
          value: RoutineIntervalType.EVERY_DAY_AT,
        },
        {
          label: RoutineIntervalTypeLabel[RoutineIntervalType.EVERY],
          value: RoutineIntervalType.EVERY,
        },
      ],
      routineIntervalUnities: [
        {
          label: RoutineIntervalUnityLabel[RoutineIntervalUnity.SECONDS],
          value: RoutineIntervalUnity.SECONDS,
        },
        {
          label: RoutineIntervalUnityLabel[RoutineIntervalUnity.MINUTES],
          value: RoutineIntervalUnity.MINUTES,
        },
        {
          label: RoutineIntervalUnityLabel[RoutineIntervalUnity.HOURS],
          value: RoutineIntervalUnity.HOURS,
        },
      ],
      routines: [],
    };
  },
  computed: {
    companyWritePermission() {
      return this.$can(this.$actionsDefault.Escrita, this.subjectPermission);
    },
  },
  watch: {
    routinesProp() {
      if (Array.isArray(this.routinesProp) && this.routinesProp.length) {
        this.routines = this.routinesProp;
      }
    },
  },
  methods: {
    hasInvalidFields(index) {
      if (!this.veeErrors || this.veeErrors.items.length < 1) {
        return false;
      }
      return this.veeErrors.items.some((item) => {
        return item.field.includes(`-${index}`);
      });
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    validateTime(index) {
      const [hours, minutes] = this.routines[index].intervalValue.split(':');
      if (parseInt(hours) > 23) {
        this.routines[index].intervalValue = '23:' + minutes;
      }

      if (parseInt(minutes) > 59) {
        this.routines[index].intervalValue = hours + ':59';
      }
    },
    saveConfig(routine) {
      const payload = {
        id: routine.id,
        name: routine.name,
        interval_type: routine.intervalType,
        interval_value: routine.intervalValue,
        interval_unity: routine.intervalUnity,
        lock_in_minutes: Number(routine.lockInMinutes) || null,
        active: routine.active,
      };
      this.$emit('save-routine', payload);
    },
  },
};
</script>

<style lang="scss" scoped></style>
